import ViewBase from "../../view-base.view";
import 'CssFolder/schedule/jpo/jpo.scss';
import { formats as FORMATS } from '../../../config/constants';
import moment from 'moment';
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { Dialog, Icon, Icons, Intent } from "construct-ui";
import scheduleModel from "../../../models/schedule/jpo-schedule.model";
import JPOScheduleMapView from "./jpo-schedule-map.view";
import JPOScheduleTimeLineView from "./jpo-schedule-timeline.view";
import { v4 as uuid } from "uuid";
import { codeMasterType, ROUTE_PLAN_COLORS_SET } from "../../../config/constants";
import JPOScheduleCalendarView from "./jpo-schedule-calendar.view";


export default function JPOScheduleView() {
  ViewBase.call(this);

  const DEFAULT_PAGINATION = {
    pageIndex: 1,
    pageSize: 10,
    total: 0
  };
  const DEFAULT_FILTER_PARAMS = Object.freeze({
    date: moment().format(FORMATS.dateFormat),
    bu: {},
    quickSearch: ''
  });

  let pagination = structuredClone(DEFAULT_PAGINATION);;


  let inputFilter = structuredClone(Object.assign({}, DEFAULT_FILTER_PARAMS));
  let schedules = [];
  let dataVersion = "";
  let showDetails = false;
  let selectedItem = {};
  let buTypes = [];
  let outsideParams = {};

  const getScheduleRoute = () => {
    this.showLoading();
    scheduleModel.getScheduleRoute(
      (result) => {
        schedules = result.data;
        pagination.total = result.total;
        dataVersion = uuid();
        this.hideLoading();
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      {
        fromDate: moment(inputFilter.date, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        toDate: moment(inputFilter.date, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
        quickSearch: inputFilter.quickSearch,
        bu: inputFilter.bu.code
      })

  }
  const getBUTypes = () => {
    buTypes = [];
    scheduleModel.getSchedulePlanAndActualCodeMaster(
      (result) => {
        if (result) {
          buTypes = result;
          inputFilter.bu = outsideParams.bu && outsideParams.bu.code ? outsideParams.bu : buTypes.length > 0 ? buTypes[0] : {};
          if (outsideParams.date) {
            inputFilter.date = outsideParams.date
          }
          getScheduleRoute();
        }
      },
      (error) => {
        this.handleError(error);
      },
      {
        type: codeMasterType.bu,
      }
    )
  }
  const onSearch = () => {
    pagination = structuredClone(DEFAULT_PAGINATION);
    getScheduleRoute();
  }
  const onPageChanged = (p) => {
    pagination = p;
    getScheduleRoute();
  }
  const onDetailsView = (schedule, idx) => {
    selectedItem = {
      color: ROUTE_PLAN_COLORS_SET[idx],
      userId: schedule.userID,
      scheduleDate: schedule.scheduleDate,
      userName: schedule.userName
    };
    showDetails = true;
  }
  let onInit = () => {
    getBUTypes();

  }

  return {
    oninit: ({ attrs }) => {
      outsideParams = m.route.param();
      onInit();
    },
    oncreate: function (vnode) {

    },
    view: (vnode) => {
      return [
        m('.jpo-schedule', [
          m(JPOScheduleMapView, {
            schedules: schedules,
            dataVersion: dataVersion,
            colors: ROUTE_PLAN_COLORS_SET
          }),
          m('div', { style: "position:absolute;top:-80px;display:flex;right: 5px;" }, [
            m('div', m(DatePickerComponent, {
              class: 'form-control',
              date: inputFilter.date,
              onselect: (e) => {
                inputFilter.date = moment(e.detail.date).format(FORMATS.dateFormat);
                onSearch();
              }
            })),
            (buTypes.length > 1) &&
            m('.ps-2.col-sm-3', m(SingleSelectComponent, {
              id: 'bu',
              items: buTypes,
              selectedItem: inputFilter.bu,
              onSelect: (s) => {
                inputFilter.bu = s;
                onSearch();
              },
            })),
            m('.ps-2',
              m('.d-flex.justify-content-between.align-items-center.form-control.form-control-bg.select-list.cursor-pointer',
                m('input.flex-fill.select-list.text-start.p-0.me-2', {
                  autocomplete: 'off',
                  type: 'text',
                  placeholder: 'Search',
                  value: inputFilter.quickSearch,
                  onkeyup: (e) => {
                    inputFilter.quickSearch = e.target.value;
                    if (e.key === 'Enter') {
                      onSearch();
                    }
                  },
                  style: {
                    border: 'none',
                    background: 'transparent',
                  }
                }),
                m(Icon,
                  {
                    name: Icons.SEARCH,
                    intent: Intent.PRIMARY,
                    onclick: () => { onSearch(); }
                  }
                )
              )
            )
          ]),
          m(JPOScheduleTimeLineView, {
            schedules: schedules,
            dataVersion: dataVersion,
            pagination: pagination,
            colors: ROUTE_PLAN_COLORS_SET,
            onDetailsView: onDetailsView,
            onPageChanged: onPageChanged
          })

        ]
        ),
        showDetails && m(Dialog, {
          isOpen: showDetails,
          onClose: () => { showDetails = false; selectedItem = {}; },
          closeOnOutsideClick: false,
          transitionDuration: 200,
          title: `${this.getText("LT00001311", "Calendar")} - ${selectedItem?.userName}`,
          content: m(JPOScheduleCalendarView, selectedItem),
          "class": "jpo-dialog"
        }),
        this.getBaseViews()

      ];
    }
  }
}
